<template>
  <div class="CadastroConfigFuncao">
    <el-button  v-if="permissao.editar_configuracoes"
      style="float: left; padding: 5px 5px"
      @click="dialogFormVisible = true"
      icon="el-icon-circle-plus-outline"
      type="primary"
    >Novo Grupo</el-button>
    <br />
    <br />
    <br />
    <el-table :data="listGrupos" empty-text="Sem dados!">
      <el-table-column property="label" label="Grupo"></el-table-column>
      <el-table-column prop="acao" label="Ação" width="110" filter-placement="bottom-end">
        <template  v-if="permissao.editar_configuracoes" slot-scope="scope">
          <el-button-group>
            <el-tooltip  v-if="permissao.editar_configuracoes" class="item" effect="light" content="Editar Grupo" placement="top">
              <el-button
                size="mini"
                type="primary"
                @click="handleEditarGrupos(scope.$index, scope.row)"
                icon="el-icon-edit"
              ></el-button>
            </el-tooltip>
            <el-tooltip  v-if="permissao.excluir_configuracoes" class="item" effect="light" content="Excluir Grupo" placement="top">
              <el-button
                size="mini"
                type="danger"
                @click="handleDeleteGrupos(scope.$index, scope.row)"
                icon="el-icon-delete"
              ></el-button>
            </el-tooltip>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!-- DIALOG DE CADASTRO DE GRUPO -->
    <el-dialog title="Novo Grupo" :visible="dialogFormVisible" :show-close="false">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        :label-position="labelPosition"
        class="demo-ruleForm"
      >
        <el-form-item label="Grupo" prop="grupo">
          <el-input v-model="ruleForm.grupo"></el-input>
        </el-form-item>

        <!-- ***************************************************************  -->
        <el-tree
          :data="listRegras"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="tree"
          highlight-current
          :props="defaultProps"
        ></el-tree>

        <div class="buttons">
          <el-button @click="getTodos">Seleciona Todos</el-button>
          <el-button @click="resetChecked">Limpa Todos</el-button>
        </div>
        <!-- ********************************************* -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">Salvar</el-button>
      </span>
    </el-dialog>

    <!-- DIALOG DE EDIÇÃO DE GRUPO -->
    <el-dialog title="Alterar Grupo" :visible="dialogFormEditVisible" :show-close="false">
      <el-form
        :model="ruleEditForm"
        :rules="rules"
        ref="ruleEditForm"
        :label-position="labelPosition"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="5" :lg="4" :xl="4">
            <el-form-item label="Código" prop="id">
              <el-input v-model="ruleEditForm.id" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="19" :lg="20" :xl="20">
            <el-form-item label="Grupo" prop="grupo">
              <el-input v-model="ruleEditForm.grupo"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- ********************************************* -->
        <el-tree
          :data="listRegras"
          show-checkbox
          default-expand-all
          node-key="id"
          ref="treeEdicao"
          highlight-current
          :props="defaultProps"
        ></el-tree>
        <div class="buttons">
          <el-button @click="getTodosEditar">Seleciona Todos</el-button>
          <el-button @click="resetCheckedEditar">Limpa Todos</el-button>
        </div>
        <!-- *************************************************** -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleEditFechar()">Cancelar</el-button>
        <el-button type="primary" @click="submitEditForm('ruleEditForm')">Salvar</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import FuncoesUteis from "../../plugins/FuncoesUteis";
// import GruposUsersPermissoes from "@/components/configuracoes/GruposUsersPermissoes.vue";

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  // components: {
  //   GruposUsersPermissoes,
  // },

  data() {
    return {
      /*******************REGRAS****************************/
      listRegras: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      todasPermissoes: [],
      permissoes: [],
      /*******************FIM REGRAS***********************/
      labelPosition: "right",
      dialogFormVisible: false,
      dialogFormEditVisible: false,
      listGrupos: [],
      permissao: {},
      ruleForm: {
        grupo: "",
      },
      ruleEditForm: {
        grupo: "",
        id: "",
      },
      rules: {
        grupo: [
          {
            required: true,
            message: "Informe o nome do Grupo",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    if (!this.permissao.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    axios
      .get(url + "/regras", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listRegras = response.data["dados"];
          this.todasPermissoes = response.data["todos"];
          // this.loading = false;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });

    axios
      .get(url + "/grupos_list", {
        headers: {
          Authorization: "Bearer " + this.$store.state.token,
        },
      })
      .then((response) => {
        if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          this.listGrupos = response.data;
          this.loading = false;
        }
      })
      .catch((err) => {
        this.total = "erro" + err;
      });
  },
  methods: {
    getDadosGrupo: function () {
      axios
        .get(url + "/grupos_list", {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          if (response.data.status == "Token is Expired" || response.data.status == "Token is Invalid" || response.data.status == "Authorization Token not found") {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.listGrupos = response.data;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.total = "erro" + err;
        });
    },
    //CADASTRO DADOS
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormVisible = false;
          this.ruleForm.grupo = "";
          this.$refs.tree.setCheckedKeys([]);
        })
        .catch(() => {
          this.dialogFormVisible = true;
        });
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let permissoes = this.$refs.tree.getCheckedKeys();
          let p = "";
          for (let i = 0; i < permissoes.length; i++) {
            p = p + permissoes[i] + "|";
          }
          let dados = {
            grupo: this.ruleForm.grupo,
            permissoes: p,
          };
          axios
            .post(url + "/grupos_register/", dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormVisible = false;
              this.ruleForm.grupo = "";
              this.$refs.tree.setCheckedKeys([]);
              this.getDadosGrupo();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormVisible = false;
              this.ruleForm.grupo = "";
              this.$refs.tree.setCheckedKeys([]);
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //FIM CADASTRO DADOS
    //EXCLUIR DADOS RENTABILIDADE
    handleDeleteGrupos(index, row) {
      this.$confirm("Tem certeza que deseja excluir este registro?", "Aviso", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(() => {
          axios
            .delete(url + "/grupos_excluir/" + row.id, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              //this.itens = response.data;
              this.$notify({
                title: "Sucesso",
                message: "Registro excluído com Sucesso!",
                type: "success",
              });
              this.getDadosGrupo();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
                type: "error",
              });
            });
        })
        .catch(() => {});
    },
    //FIM EXCLUIR DADOS COMISSÃO
    //EDITAR DADOS GRUPOS
    handleEditarGrupos(index, row) {
      axios
        .get(url + "/grupos/" + row.id, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((resp) => {
          this.dialogFormEditVisible = true;
          this.ruleEditForm.grupo = resp.data.grupo;
          this.ruleEditForm.id = row.id;
          this.ruleEditForm.perm = resp.data.permissoes;
          this.permissoes = resp.data.permissoes.split("|");
        })
        .catch((err) => {
          this.$notify({
            title: "Erro",
            message:
              "Erro ao excluir os dados! Tente novamente mais tarde!" + err,
            type: "error",
          });
          this.dialogFormEditVisible = false;
        })
        .finally(() => {
          this.$refs.treeEdicao.setCheckedKeys([]);
          this.$refs.treeEdicao.setCheckedKeys(this.permissoes);
        });
    },

    //EDITAR DADOS GRUPOS
    submitEditForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let permissoes = this.$refs.treeEdicao.getCheckedKeys();
          let p = "";
          for (let i = 0; i < permissoes.length; i++) {
            p = p + permissoes[i] + "|";
          }

          let dados = {
            grupo: this.ruleEditForm.grupo,
            permissoes: p,
          };
          axios
            .put(url + "/grupos_register/" + this.ruleEditForm.id, dados, {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            })
            .then(() => {
              this.$notify({
                title: "Sucesso",
                message: "Registro Salvo com sucesso!",
                type: "success",
              });
              this.dialogFormEditVisible = false;
              this.ruleEditForm.grupo = "";
              this.$refs.treeEdicao.setCheckedKeys([]);
              this.getDadosGrupo();
            })
            .catch((err) => {
              this.$notify({
                title: "Erro",
                message:
                  "Erro ao cadastrar os dados! Tente novamente mais tarde!" +
                  err,
                type: "error",
              });
              this.dialogFormEditVisible = false;
              this.ruleEditForm.grupo = "";
              this.$refs.treeEdicao.setCheckedKeys([]);
            });
        } else {
          this.$message({
            type: "info",
            message: "Informe os dados corretamente!",
          });
          return false;
        }
      });
    },
    //LISTA DE REGRAS
    getTodos() {
      this.$refs.tree.setCheckedKeys(this.todasPermissoes);
    },
    getTodosEditar() {
      this.$refs.treeEdicao.setCheckedKeys(this.todasPermissoes);
    },

    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    resetCheckedEditar() {
      this.$refs.treeEdicao.setCheckedKeys([]);
    },

    //FIM LISTA DE REGRAS
    //FECHAR DIALOG EDIT
    handleEditFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.dialogFormEditVisible = false;
          //this.ruleForm.grupo = "";
          //this.$refs.tree.setCheckedKeys([]);
        })
        .catch(() => {
          this.dialogFormEditVisible = true;
        });
    },
    doSomething() {
      alert("teste");
    },
  },
};
</script>